<template>
    <!-- <div v-if="show" class="ttcdialog" :style="{minHeight:(3 * 60 + 120) + 'px'}">
        <ul class="flex between pad20" :style="{height:Math.ceil((ttcDialogOption.length / 4)) * 60 + 120 + 'px',minHeight:(3 * 60 + 120) + 'px'}" style="overflow-y: scroll">
            <li v-for="(item,index) in ttcDialogOption" :key="item.id" @click="handleClick(item,index)" class="BGf6 width22 center mb20 size14" :class="{'active': isActive(item.id)}">{{ item.name }}</li>
        </ul>
    </div>  -->
    <div v-if="show" class="ttcdialog" :style="{minHeight:(3 * 60 + 120) + 'px'}">
        <ul class="box pad20" :style="{height:Math.ceil((ttcDialogOption.length / 4)) * 60 + 120 + 'px',minHeight:(3 * 60 + 120) + 'px'}" style="overflow-y: scroll">
            <li v-for="(item,index) in ttcDialogOption" :key="item.id" @click="handleClick(item,index)" class="BGf6  mb20 size14 item" :class="{'active': isActive(item.id)}">{{ item.name }}</li>
        </ul>
    </div>
</template>
<script setup>
import { ref,defineEmits,defineProps,watchEffect, watch } from "vue";


const props = defineProps( {
    ttcdialog: {
        type: Boolean,
        default: false
    },
    ttcDialogOption: {
        type: Array,
        default: () => []
    },
    currentId: {
        type: Number,
        default: 1
    }
})

const show = ref(props.ttcdialog)

// const option = ref([]);

const currentLi = ref(props.currentId);
// currentLi.value = toRefs(props.currentId)
const emits = defineEmits(["updatettcdialog"])
const handleClick = (val,index) => {
    currentLi.value = val.id
    emits("updatettcdialog", {show: false,val: val,clickIndex: index})
}

const isActive = (val) => {
    return currentLi.value === val
}

// //获取列表
// const cateId = ref(1)
// async function getList(cateId) {
//     const data = {
//         cate_id: cateId
//     }
//     const backData = await getCultureList(data)
//     console.log(backData)
//     option.value = backData.data
//     currentLi.value = backData.data[0].id
// }

// getList(cateId.value)

watchEffect(() => { 
    props.ttcdialog === true ? show.value = true : show.value = false
})
watch(props,() => {
    currentLi.value = props.currentId
},{deep: true})
</script>
<style scoped>
.ttcdialog {
    position: absolute;
    top: 51px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    overflow: auto;
}
.ttcdialog li {
    padding: 23px 0;
}
.ttcdialog li:nth-child(4) {
    margin-right: 0;
}
.ttcdialog li.active {
    background-color: #3F7C93;
    color: #ffffff;
}
.box{
    display: grid;
    grid-template-columns: repeat(4 ,1fr);
    
    gap: 10px;
}
.box .item{
    text-align: center;
}
</style>